
import React, { useState, useEffect, useRef } from "react";

import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Card from "@material-ui/core/Card";
import Avatar from "@material-ui/core/Avatar";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import Chip from "@material-ui/core/Chip";
import Badge from "@material-ui/core/Badge";
import Hidden from "@material-ui/core/Hidden";
import Collapse from "@material-ui/core/Collapse";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { withStyles } from "@material-ui/core/styles";
import TimerIcon from "@material-ui/icons/Timer";
import GroupIcon from "@material-ui/icons/Group";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import LanguageIcon from "@material-ui/icons/Language";
import StarIcon from "@material-ui/icons/Star";
import InfoIcon from "@material-ui/icons/Info";

import JobpositionsAutocomplete from "./JobpositionsAutocomplete";
import RegionsSelect from "./RegionsSelect";
import CompanyDetailsDialog from "./CompanyDetailsDialog";
import ConfirmDialog from "../lndbtool/general/ConfirmDialog";
import zIndex from "@material-ui/core/styles/zIndex";




const styles = theme => ({
	checkbox: {
		//padding: 0
	},
	expansionPanelSummary: {
		alignItems: "baseline"
	},
	formControl: {
		margin: theme.spacing.unit,
	},
	jobpositionslist: {
		marginLeft: 30
	},
	jobposition: {
		display: "flex"
	},
	selectedStats: {
		display: "inline-block",
		marginLeft: 10,
		textTransform: "uppercase",
		fontSize: "80%",
		color: "#999"
	},
	checkboxParent: {
		paddingBottom: 4
	},
	checkboxChild: {
		paddingTop: 4,
		paddingBottom: 4
	},
	companyResult: {
		overflowX: "hidden",
		textOverflow: "ellipsis",
		whiteSpace: "nowrap"
	},
	companyCard: {
		marginBottom: 10
	},
	companyName: {
		lineHeight: "1.2em"
	},
	favoriteCompanyName: {
		lineHeight: "1.2em",
		overflow: "hidden",
		textOverflow: "ellipsis",
		whiteSpace: "nowrap",
		fontSize: 16
	},
	selectedPositionChip: {
		marginRight: 4,
		marginTop: 4,
		height: 23,
		"& span": {
			display: "block",
			maxWidth: 280,
			fontSize: 12,
			overflowX: "hidden",
			textOverflow: "ellipsis",
			"@media (min-width: 960px) and (max-width: 1100px)": {
				maxWidth: 235
			},
			"@media (max-width: 420px)": {
				maxWidth: 255
			}
		},
		"& svg": {
			fontSize: 16
		}
	},
	favorites: {
		backgroundColor: "#eee",
		border: "12px solid #eee",
		minHeight: 300,
		maxHeight: "calc(100vh - 250px)",
		overflowY: "scroll",
	},
	mobileFavorites: {
		maxHeight: "calc(100vh - 130px)",
		overflowY: "scroll",
		maxWidth: "96vw",
	},
	mobileFavoritesListButton: {
		"&:active, &:focus, &:visited": {
			color: "#00c853!important",
		}
	},
	continueButton: {
		"&:hover, &:active, &:focus, &:visited": {
			color: "#fff!important",
		}
	},
	mobileBottomBar: {
		position: "fixed",
		bottom: 0,
		left: 0,
		width: "100%",
		backgroundColor: "#fff",
		padding: 10,
		zIndex: 100
	},
	sortInfo: {
		marginLeft: 16,
		fontSize: 12,
		"& a": {
			color: "#666",
			"& svg": {
				verticalAlign: -4,
				fontSize: 16
			}
		}
	},
	favoritesColumn: {
		position: "relative",
	},
	// favoritesColumnSticky: {
	// 	position: "sticky",
	// 	top: 10,
	// },
});

const CompanyFilter = ({ companies, setFilteredCompanyIDs, formphase, setActiveStep, isJobTypesEnabled, language, classes, signupstatus, favorites, setFavorites }) => {
	const [jobpositions, setJobPositions] = useState({});
	const [filteredCompanies, setFilteredCompanies] = useState([]);
	const [regions, setRegions] = useState({});
	const [remote, setRemote] = useState(false);
	const [homeoffice, setHomeoffice] = useState(false);
	const [parttime, setParttime] = useState(false);
	const [student, setStudent] = useState(false);
	const [foreign, setForeign] = useState(false);
	const [companyOpenInDialog, setCompanyOpenInDialog] = useState(null);
	const [moreFiltersVisible, setMoreFiltersVisible] = useState(false);
	const [mobileFavoritesVisible, setMobileFavoritesVisible] = useState(false);
	const [confirmDialog, setConfirmDialog] = useState({
		open: false
	});
	const favoritesColumnRef = useRef(null);
	const [favoritesColumnStyle, setFavoritesColumnStyle] = useState({});


	const setFilterDefaults = (cp) => {
		const newJobPositions = {};
		cp.forEach(company => {
			company.jobpositions.forEach(pos => {
				if (!newJobPositions.hasOwnProperty(pos.ID))
					newJobPositions[pos.ID] = { ...pos, selected: false };
			})
		})
		setJobPositions(newJobPositions);

		const newRegions = {};
		cp.forEach(company => {
			company.regions.forEach(reg => {
				if (!newRegions.hasOwnProperty(reg.ID))
					newRegions[reg.ID] = { ...reg, selected: false };
			})
		})
		setRegions(newRegions);

		setRemote(false);
		setHomeoffice(false);
		setParttime(false);
		setStudent(false);
		setForeign(false);
	}

	useEffect(() => {
		if (companies) {
			setFilterDefaults(companies);
		}

	}, [companies]);


	useEffect(() => {
		if (Object.keys(jobpositions).length > 0) {
			const newFilteredCompanies = companies.filter(company => {
				if (remote && !company.remote)
					return false;
				if (homeoffice && !company.homeoffice)
					return false;
				if (parttime && !company.parttime)
					return false;
				if (student && !company.student)
					return false;
				if (foreign && !company.foreign)
					return false;

				// true if at least one of the companies job positions is selected.
				// empty filter == all selected
				const jobpositions_are_empty = !Object.keys(jobpositions).some(pos_id => jobpositions[pos_id].selected);
				if (!jobpositions_are_empty) {
					const has_matching_jobpositions = company.jobpositions.some(company_pos =>
						jobpositions[company_pos.ID].parent !== 0 &&
						jobpositions[company_pos.ID].selected
					);

					if (!has_matching_jobpositions)
						return false;
				}

				// true if at least one of the companies regions is selected.
				// empty filter == all selected
				const regions_are_empty = !Object.keys(regions).some(reg_id => regions[reg_id].selected);
				if (regions_are_empty) {
					return true;
				}
				const has_matching_regions = company.regions.some(company_reg =>
					regions[company_reg.ID].parent !== 0 &&
					regions[company_reg.ID].selected
				);


				return has_matching_regions;
			});
			const filteredCompanyIDs = [];
			newFilteredCompanies.forEach((company, index) => {
				filteredCompanyIDs.push(company.id);
			});
			setFilteredCompanyIDs(filteredCompanyIDs);
			setFilteredCompanies(newFilteredCompanies);
		}
	}, [jobpositions, regions, remote, homeoffice, parttime, student, foreign]);

	const printFavorites = () => {
		return <>
			{favorites.map(favorite => {
				const company = companies.find(cp => cp.id === favorite.id);
				if (!company) return null;
				const selectedPositions = favorite.positions
					.filter(pos_id => jobpositions[pos_id] && jobpositions[pos_id].name)
					.map(pos_id => jobpositions[pos_id].name);
				return (
					<Card
						key={company.id}
						className={classes.companyCard}
					>
						<CardContent>
							<Grid container spacing={8}>
								<Grid item xs={9}>
									<Typography
										variant="h6"
										gutterBottom
										className={classes.favoriteCompanyName}
									>
										{company.name}
									</Typography>
									{selectedPositions.map((selectedPosition, positionIndex) =>
										<Chip
											key={selectedPosition}
											variant="outlined"
											label={selectedPosition}
											onClick={() => {
												setCompanyOpenInDialog(company);
											}}
											onDelete={() => {
												if (selectedPositions.length === 1) {
													setConfirmDialog({
														open: true,
														title: "Aus Favoriten entfernen?",
														message: 'Wenn du den einzigen Job entfernst, entfernst du damit auch das Unternehmen aus deinen Favoriten. Möchtest du ' + company.name + ' entfernen?',
														captionYes: "Ja",
														captionNo: "Nein",
														handleYes: () => {
															const newFavorites = favorites.filter(fav => fav.id !== company.id);
															setFavorites(newFavorites);
															setConfirmDialog({ open: false });
														},
														handleNo: () => {
															setConfirmDialog({ open: false });
														}
													});
												} else {
													console.log("remove position", selectedPosition, favorite);
													const newFavoritePositions = [...favorite.positions];
													newFavoritePositions.splice(positionIndex, 1);
													//const newFavoritePositions = favorite.positions.filter(pos_id => pos_id !== jobpositions.find(pos => pos.name === selectedPosition).ID);
													const newFavorites = favorites.map(fav => {
														if (fav.id === company.id) {
															return { id: company.id, positions: newFavoritePositions };
														} else {
															return fav;
														}
													});
													setFavorites(newFavorites);
												}
											}}
											className={classes.selectedPositionChip}
										/>
									)}
								</Grid>
								{company.logo_url &&
									<Grid item xs={3} align="right">
										<img src={company.logo_url} alt={company.name} style={{ width: 60, marginBottom: 8 }} />
									</Grid>
								}
								<Grid item xs={12} align="right">
									<Button
										size="small"
										onClick={() => {
											const newFavorites = favorites.filter(fav => fav.id !== company.id);
											setFavorites(newFavorites);
										}}
									>
										{language === "en" ? "remove" : "entfernen"}
									</Button>
									{" "}
									<Button
										size="small"
										color="default"
										variant="contained"
										onClick={() => {
											setCompanyOpenInDialog(company);
										}}
									>
										{language === "en" ? "change" : "ändern"}
									</Button>
								</Grid>
							</Grid>
						</CardContent>
					</Card>
				);
			})
			}
		</>;
	}
	const getWorkingTimeOffers = (company) => {
		const workingTimeOffers = [];
		if (company.remote) workingTimeOffers.push("Remote");
		if (company.homeoffice && language === "de") workingTimeOffers.push("Positionsbedingt teilweise Homeoffice");
		if (company.homeoffice && language === "en") workingTimeOffers.push("Partial remote work available, depending on the position");
		if (company.parttime && language === "en") workingTimeOffers.push("Part-time");
		if (company.parttime && language === "de") workingTimeOffers.push("Teilzeit");
		if (company.student && language === "en") workingTimeOffers.push("Student jobs");
		if (company.student && language === "de") workingTimeOffers.push("Studentenjobs");
		return workingTimeOffers;
	}

	if (!companies || companies.length === 0) return <div />;

	const scrollHandler = _ => {
		if (!favoritesColumnRef.current) return;
		const box = favoritesColumnRef.current.parentNode.getBoundingClientRect();
		if (box.top < 140) {
			setFavoritesColumnStyle({
				position: "fixed",
				top: 140,
				width: box.width - 16,
			});
		} else {
			setFavoritesColumnStyle({
				position: "relative",
			});
		}
	};
	useEffect(() => {
		window.addEventListener("scroll", scrollHandler, true);
		return () => {
			window.removeEventListener("scroll", scrollHandler, true);
		};
	}, []);

	const jobpositionsOptions = [];
	Object.keys(jobpositions).forEach(pos_id => {
		const pos = jobpositions[pos_id];
		if (pos.parent === 0) {
			const subPositions = Object.keys(jobpositions).filter(subPos => jobpositions[subPos].parent === pos.ID).map(subPos => jobpositions[subPos]);
			const searchTerms = [pos.name];
			subPositions.forEach(subPos => {
				searchTerms.push(subPos.name);
			});
			jobpositionsOptions.push({
				id: pos.ID,
				value: searchTerms.join(" "),
				name: pos.name,
				has_children: true,
				subtitle: language === "en" ? "select all" : "alle auswählen",
			});

			subPositions.forEach(subPos => {
				jobpositionsOptions.push({
					id: subPos.ID,
					value: pos.name + " " + subPos.name,
					name: subPos.name,
					has_children: false,
					subtitle: pos.name,
				});
			});
		}

	});
	const regionsOptions = Object.keys(regions)
		.filter(reg_id => regions[reg_id].parent !== 0)
		.map(reg_id => {
			const reg = regions[reg_id];
			return {
				id: reg.ID,
				value: reg.name,
				label: reg.name,
			}
		});

	return (
		<div>
			<form key="filterCompanies">
				<Grid
					container
					direction="row"
					justify="flex-start"
					alignItems="flex-start"
					spacing={24}
				>
					<Grid item xs={12} md={Object.keys(regions).length > 0 ? 7 : 12}>
						<JobpositionsAutocomplete
							jobpositionsOptions={jobpositionsOptions}
							setJobPositions={setJobPositions}
							language={language}
						/>
					</Grid>
					{Object.keys(regions).length > 0 &&
						<Grid item xs={12} md={5}>
							<RegionsSelect
								regionsOptions={regionsOptions}
								setRegions={setRegions}
								language={language}
							/>
						</Grid>
					}
					{/* <Grid item xs={12}>
						<br />
						{language === "en"
							? <Typography>
								Description sentence...
							</Typography>
							: <Typography>
								Beschreibungssatz
							</Typography>
						}
					</Grid> */}
					{isJobTypesEnabled &&
						<Grid item xs={12} align="right">
							<Button
								size="small"
								onClick={() => {
									setMoreFiltersVisible(!moreFiltersVisible);
								}}
							>
								{language === "en" ? "more filters " : "mehr Filter "} <ExpandMoreIcon />
							</Button>
						</Grid>
					}
					<Grid item xs={12}>
						<Collapse in={moreFiltersVisible}>
							<Grid
								container
								direction="row"
								justify="flex-start"
								alignItems="flex-start"
								spacing={24}
							>
								<Grid item xs={12}>
									<FormControlLabel
										control={
											<Checkbox
												checked={homeoffice}
												name="homeoffice"
												onChange={(e) => setHomeoffice(e.target.checked)}
												color="primary"
											/>
										}
										label={
											<span>
												{
													language === "en"
														? "Homeoffice available"
														: "Homeoffice"
												}
												<span className={classes.selectedStats}>
													({companies.filter(company => company.homeoffice).length})
												</span>
											</span>
										}
									/>
									{/* <FormControlLabel
										control={
											<Checkbox
												checked={remote}
												name="remote"
												onChange={(e) => setRemote(e.target.checked)}
												color="primary"
											/>
										}
										label={
											<span>
												{
													language === "en"
														? "Remote available"
														: "Remote"
												}
												<span className={classes.selectedStats}>
													({companies.filter(company => company.remote).length})
												</span>
											</span>
										}
									/> */}
									<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
									<FormControlLabel
										control={
											<Checkbox
												checked={parttime}
												name="parttime"
												onChange={(e) => setParttime(e.target.checked)}
												color="primary"
											/>
										}
										label={
											<span>
												{
													language === "en"
														? "Part-time Job"
														: "Teilzeit"
												}
												<span className={classes.selectedStats}>
													({companies.filter(company => company.parttime).length})
												</span>
											</span>
										}
									/>
									<FormControlLabel
										control={
											<Checkbox
												checked={student}
												name="student"
												onChange={(e) => setStudent(e.target.checked)}
												color="primary"
											/>
										}
										label={
											<span>
												{
													language === "en"
														? "Student Job"
														: "Stundentenjobs"
												}
												<span className={classes.selectedStats}>
													({companies.filter(company => company.student).length})
												</span>
											</span>
										}
									/>

									{/* <br />
									<FormControlLabel
										control={
											<Checkbox
												checked={foreign}
												name="foreign"
												onChange={(e) => setForeign(e.target.checked)}
												color="primary"
											/>
										}
										label={
											<span>
												{
													language === "en"
														? "Show me only companies that are willing to hire employees from abroad"
														: "Nur Unternehmen, die bereit sind Dienstnehmer aus Drittstaaten einzustellen"
												}
												<span className={classes.selectedStats}>
													({companies.filter(company => company.foreign).length})
												</span>
											</span>
										}
									/> */}
								</Grid>
							</Grid>
						</Collapse>
					</Grid>
				</Grid>
			</form>

			<Grid
				container
				direction="row"
				justify="space-between"
				alignItems="stretch"
				spacing={16}
			>
				<Grid item xs={12}>
					{filteredCompanies.length < companies.length &&
						<Typography variant="caption">
							{language === "en"
								? "Filtered " + filteredCompanies.length + " of " + companies.length + " Companies."
								: filteredCompanies.length + " von " + companies.length + " Unternehmen gefiltert."
							}
						</Typography>
					}
					{filteredCompanies.length === 0 &&
						<Typography color="error" variant="caption">
							Mit diesen Filtereinstellungen gibt es leider kein Unternehmen für dich. <br />
							Bitte prüfe deine Einstellungen nochmal.
						</Typography>
					}
					{filteredCompanies.length === 1 &&
						<Typography color="error" variant="caption">
							Aktuell bietet nur ein Unternehmen Jobs an, die deinen Kriterien entsprechen, du könntest dich aber bei bis zu 7 Unternehmen bewerben. <br />
							Wenn du das möchtest, ändere deine Filter-Einstellungen.
						</Typography>
					}
					{filteredCompanies.length > 1 && filteredCompanies.length < 7 &&
						<Typography color="error" variant="caption">
							Aktuell bieten nur {filteredCompanies.length} Unternehmen Jobs an, die deinen Kriterien entsprechen, du könntest dich aber bei bis zu 7 Unternehmen bewerben. <br />
							Wenn du das möchtest, ändere deine Filter-Einstellungen.
						</Typography>
					}
				</Grid>
				<Grid item xs={12} md={formphase === "registration" ? 7 : 12}>
					<div>
						<Typography variant="h6" inline>
							{language === "en" ? "Companies" : "Unternehmen"} ({filteredCompanies.length}/{companies.length})
						</Typography>
						<Typography variant="caption" className={classes.sortInfo} inline>
							<a href="https://www.langenachtderbewerbung.com/reihung-der-unternehmen/" target="_blank" rel="noopener noreferrer">
								<InfoIcon fontSize="small" /> {language === "en" ? "About the ranking of companies" : "Infos zur Reihung der Unternehmen"}
							</a>
						</Typography>
					</div>
					{filteredCompanies.map(company => {
						const workingTimeOffers = getWorkingTimeOffers(company);
						let jobPositionsDescription = company.jobpositions.filter(pos => pos.parent !== 0).length + " " + (language === "en" ? "Jobs" : "Jobs");
						const selectedParentJobPosition = Object.keys(jobpositions).find(pos_id => jobpositions[pos_id].parent === 0 && jobpositions[pos_id].selected);
						if (selectedParentJobPosition) {
							const numAvailableJobs = company.jobpositions.filter(pos => parseInt(pos.parent) === parseInt(selectedParentJobPosition)).length;
							if (numAvailableJobs === 1) {
								jobPositionsDescription = "1 " + (language === "en" ? "Job in" : "Job in") + " " + jobpositions[selectedParentJobPosition].name;
							} else {
								jobPositionsDescription = company.jobpositions.filter(pos => parseInt(pos.parent) === parseInt(selectedParentJobPosition)).length + " " + (language === "en" ? "Jobs in" : "Jobs in") + " " + jobpositions[selectedParentJobPosition].name;
							}
						} else {
							const selectedSingleJobPositions = Object.keys(jobpositions).filter(pos_id => jobpositions[pos_id].parent !== 0 && jobpositions[pos_id].selected);
							if (selectedSingleJobPositions.length === 1) {
								jobPositionsDescription = jobpositions[selectedSingleJobPositions[0]].name;
							}
						}

						const currentFavorites = favorites.filter(fav => fav.id === company.ID);
						const isCurrentFavorite = currentFavorites.length > 0;

						const languageRequirements = [];
						let languageRequirementsDescription = "";

						if (company.german && company.german.length > 0 && company.german !== "Egal") {
							languageRequirements.push((language === "en" ? "German" : "Deutsch"));
						}
						if (company.english && company.english.length > 0 && company.english !== "Egal") {
							languageRequirements.push((language === "en" ? "English" : "Englisch"));
						}
						if (languageRequirements.length === 2) {
							if (company.language_join === "UND") {
								if (language === "en") {
									languageRequirementsDescription = languageRequirements[0] + " and " + languageRequirements[1];
								} else {
									languageRequirementsDescription = languageRequirements[0] + " und " + languageRequirements[1];
								}
							} else {
								if (language === "en") {
									languageRequirementsDescription = languageRequirements[0] + " or " + languageRequirements[1];
								} else {
									languageRequirementsDescription = languageRequirements[0] + " oder " + languageRequirements[1];
								}
							}
						} else if (languageRequirements.length === 1) {
							if (language === "en") {
								languageRequirementsDescription = languageRequirements[0];
							} else {
								languageRequirementsDescription = languageRequirements[0];
							}
						}



						return (
							<Card
								key={company.id}
								className={classes.companyCard}
							>
								<CardContent>
									<Grid container spacing={8} alignItems="stretch">
										<Grid item xs={9} md={10}>
											<Typography
												variant="h6"
												gutterBottom
												className={classes.companyName}
											>
												{company.name}
											</Typography>
											<Chip
												avatar={
													<Avatar>
														<GroupIcon />
													</Avatar>
												}
												onClick={() => {
													setCompanyOpenInDialog(company);
												}}
												variant="outlined"
												label={jobPositionsDescription}
											/>
										</Grid>
										{company.logo_url &&
											<Grid item xs={3} md={2} align="right">
												<img src={company.logo_url} alt={company.name} style={{ width: 60 }} />
											</Grid>
										}
										<Grid item xs={12} md={8}>
											{workingTimeOffers.length > 0 &&
												<Grid container spacing={8}>
													<Grid item xs={1}>
														<TimerIcon fontSize="small" />
													</Grid>
													<Grid item xs={11}>
														<Typography
															variant="caption"
														>
															{workingTimeOffers.join(", ")}
														</Typography>
													</Grid>
												</Grid>
											}
											{company.current_location && company.current_location.length > 0 &&
												<Grid container spacing={8}>
													<Grid item xs={1}>
														<LocationOnIcon fontSize="small" />
													</Grid>
													<Grid item xs={11}>
														<Typography
															variant="caption"
														>
															{company.current_location.length < 65 ?
																company.current_location
																:
																company.current_location.substring(0, 65) + "..."
															}
														</Typography>
													</Grid>
												</Grid>
											}
											{languageRequirementsDescription !== "" &&
												<Grid container spacing={8}>
													<Grid item xs={1}>
														<LanguageIcon fontSize="small" />
													</Grid>
													<Grid item xs={11}>
														<Typography
															variant="caption"
														>
															{languageRequirementsDescription}
														</Typography>
													</Grid>
												</Grid>
											}
										</Grid>
										<Grid item xs={12} md={4} align="right" style={{ alignContent: "flex-end" }}>
											<br />
											<Button
												size="small"
												color={isCurrentFavorite && formphase === "registration" ? "default" : "primary"}
												variant="contained"
												onClick={() => {
													setCompanyOpenInDialog(company);
												}}
											>
												{language === "en" && formphase !== "registration" && "info & jobs"}
												{!isCurrentFavorite && language === "en" && formphase === "registration" && "Select jobs"}
												{language !== "en" && formphase !== "registration" && "Info & Jobs"}
												{!isCurrentFavorite && language !== "en" && formphase === "registration" && "Jobs auswählen"}
												{isCurrentFavorite && formphase === "registration" && language === "en" && "change"}
												{isCurrentFavorite && formphase === "registration" && language !== "en" && "ändern"}
											</Button>
										</Grid>
									</Grid>
								</CardContent>
							</Card>
						);
					})}
				</Grid>
				{/* invisible in pre and post_registration phase */}
				{formphase === "registration" &&
					<Hidden smDown>
						<Grid item xs={12} md={5} className={classes.favoritesColumn} >
							<div style={favoritesColumnStyle} ref={favoritesColumnRef}>
								<Typography variant="h6">
									{language === "en" ? "My job favorites" : "Meine Favoriten"} ({favorites.length}/7)<StarIcon style={{ marginLeft: 10 }} />
								</Typography>
								<div className={classes.favorites}>
									{favorites.length === 0 &&
										<Typography variant="caption">
											{language === "en" ? "Select your job favorites." : "Wähle links aus der Liste deine Wunschunternehmen und Jobs aus."}
										</Typography>
									}
									{printFavorites()}

								</div>
								<br />
								{formphase === "registration" &&
									<Button
										color="primary"
										variant="contained"
										className={classes.continueButton}
										disabled={favorites.length === 0}
										onClick={() => {
											setActiveStep(1);
										}}
									>
										{language === "en" ? "continue >" : "weiter >"}
									</Button>
								}
								{formphase === "registration" &&
									<Typography variant="caption">
										<br />
										{language === "en" ? "Choose up to 7 companies and jobs." : "Wähle links bis zu 7 Unternehmen und Jobs."}
									</Typography>
								}
							</div>
						</Grid>
					</Hidden>
				}
			</Grid>
			{formphase === "registration" &&
				<Hidden mdUp>
					<ClickAwayListener onClickAway={() => {
						if (mobileFavoritesVisible) {
							setMobileFavoritesVisible(false);
						}
					}}>
						<Card className={classes.mobileBottomBar} elevation={20}>
							<Grid container spacing={8}>
								<Collapse in={mobileFavoritesVisible}>
									<Grid item xs={12} className={classes.mobileFavorites}>
										{printFavorites()}
									</Grid>
								</Collapse>

								<Grid item xs={6}>
									{favorites.length === 0 ?
										<Typography variant="caption">
											{language === "en" ? "Select your favorite jobs." : "Wähle deine Unternehmen und Jobs aus."}
										</Typography>
										:
										<Button
											color="secondary"
											size="small"
											aria-label="Favoriten"
											onClick={() => setMobileFavoritesVisible(!mobileFavoritesVisible)}
											className={classes.mobileFavoritesListButton}>
											<Badge
												badgeContent={favorites.length}
												color="error"
												style={{ marginRight: 8 }}
											>
												<StarIcon />
											</Badge>
											{language === "en" ? "Favorites" : "Favoriten"}
										</Button>
									}
								</Grid>
								<Grid item xs={6} align="right">
									<Button
										color="primary"
										variant="contained"
										disabled={favorites.length === 0}
										onClick={() => {
											setActiveStep(1);
										}}
									>
										{language === "en" ? "continue >" : "weiter >"}
									</Button>
								</Grid>
							</Grid>
						</Card>
					</ClickAwayListener>
				</Hidden>
			}
			<CompanyDetailsDialog
				company={companyOpenInDialog}
				closeDialog={() => setCompanyOpenInDialog(null)}
				formphase={formphase}
				signupstatus={signupstatus}
				language={language}
				favorites={favorites}
				getWorkingTimeOffers={getWorkingTimeOffers}
				setFavorites={setFavorites}
			/>
			<ConfirmDialog {...confirmDialog} />
		</div>
	);

}

export default withStyles(styles)(CompanyFilter);
